import React from 'react';
import axios from 'axios';
//import AvatarEditor from 'react-avatar-editor';
import '../css/TestimonialForm.css';
import '../css/Form.css';
import '../css/UserStyle.css';
import EditUserInfoRow from '../components/EdirUserInfoRow';
import EditUserProofRow from '../components/EditUserProofRow';
import EditUserSelect from '../components/UserInfoSelect';
import UserInfoRow from '../components/UserInfoRow';
import PhoneNumberInput from '../components/PhoneNumberInput';
import { fetchUserData } from '../../../config/UserDetailsFetch';
//import { fetchUser } from '../../../config/UserDetailsPrimary';
//import { NavLink } from 'react-router-dom';
import { Save, CheckCircle } from 'react-feather';
import Loading from '../components/Loading';
import AvatarEditor from 'react-avatar-editor';
import SuccessIcon from '../components/SuccessIcon';
import { UserRegistration } from '../../../config/UserRegistration';
import withNavigation from '../components/WithNavigation';



class UserNewEntry extends React.Component  {
    constructor(props) {
        super(props);
        this.state = {
            image: null,
            scale: 1,
            allowZoomOut: false,
            rotate: 0,
            position: { x: 0, y: 0 },
            x: null,
            y: null,
            imageLoaded: false,
            mobileExists: null,
            mobileExistsMessage: null,
            emailExists: null,
            emailExistsMessage: null,
            emailNotValid: null,
            saveDisabled: false,
            preview: null,
            width: 250,
            height: 250,
            user: props.user,
            joiningDate: '',
            days: 0,
            months: 0,
            years: 0,
            resignDate: null,
            method: 'insert', // Assuming default method is 'insert'
            isLoading: false,
            submitLoading: false,
            mobileLoading: false,
            emailLoading: false,
            pdfUrls: "",
            pdfFileName: "",
            StudentData: {
                id: '',
                personal_email: '',
                mobile_ISD: '91',
                mobile: '',
                name: '',
                middle_name: '',
                last_name: '',
                role: '',
                address_1: '',
                address_2: '',
                address_3: '',
                city: '',
                state: '',
                pincode: '',
                image: null,
                original_image: null,
                scale: 1,
                allowZoomOut: false,
                rotate: 0,
                position: { x: 0, y: 0 },
                x: null,
                y: null,
                preview: null,
                width: 250,
                height: 250,
                join_date: null,
                resign_date: '',
                id_no_1: '',
                id_type_1: null,
                pdfUrls: "",
                id_proof_1: null,
                id_no_2: '',
                id_type_2: null,
                id_proof_2: null,
                user_type: null,
                user_level: null,
                id_proof: '',
                method: '',
                image_loc: null,
                position_x: null,
                position_y: null,
                id_proof_file_2: null,
            },
            DatabaseImg: {
                images: null,
                pdfUrls: "",
                id_proof_1: null,
                id_proof_2: null,
                mobile: null,
                email_address: null,
            },



        };
        this.handleFileChange = this.handleFileChange.bind(this);
        this.editorRef = React.createRef();
        this.rotateInputRef = React.createRef();
        this.scaleInputRef = React.createRef();
        //this.fileInputRef = React.createRef();

    }

   
    






    calculateDuration = (joiningDate, resignDate) => {
        const joinDate = new Date(joiningDate);
        const specifiedDate = resignDate ? new Date(resignDate) : new Date();

        // Calculate the difference in milliseconds
        const diffTime = Math.abs(specifiedDate - joinDate);
        // Convert milliseconds to days
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

        // Calculate years
        const years = Math.floor(diffDays / 365);
        // Calculate remaining days
        const remainingDays = diffDays % 365;

        // Calculate months based on remaining days
        const months = Math.floor(remainingDays / 30);
        // Calculate remaining days
        const days = remainingDays % 30;

        this.setState({ years, months, days });

    };
    fetchDatafromDB = async () => {
        //const { user } = this.props; // Extract the user prop
        const postId = localStorage.getItem('postId');
        const userType = localStorage.getItem('userType');
        const update_id = localStorage.getItem('postId');
        console.log('Post ID from local storage:', postId);
        //console.log('Post ID : ', postId);

        try {
            if (postId) {

                this.setState({ isLoading: true });
                const data = await fetchUserData(postId, userType); // Pass only the ID to fetchUserData
                const combinedObj = { ...data[0], ...data[1] };
                 

                if (combinedObj && Object.keys(combinedObj).length > 0) {
                    if (combinedObj.image) {
                        combinedObj.image = `https://yesedacademy.com/database/${combinedObj.image}`;
                    }
                    if (combinedObj.original_image) {
                        combinedObj.original_image = `https://yesedacademy.com/database/${combinedObj.original_image}`;
                    }

                    console.log('Length of combinedObj:', combinedObj.image);


                    this.setState({

                        StudentData: {
                            ...combinedObj,
                            position: { x: combinedObj.position_x, y: combinedObj.position_y },
                           
                        },
                        DatabaseImg: combinedObj,// Set StudentData state
                        method: 'update',
                        scale: combinedObj.scale,
                        rotate: combinedObj.rotate,
                        position: { x: combinedObj.position_x, y: combinedObj.position_y }

                        // Update method if needed
                    }, () => {

                        this.setState(prevState => ({
                            StudentData: { ...prevState.StudentData, method: 'update' }
                        }));
                        localStorage.removeItem('postId');
                        const postId = '';
                        console.log('Post ID : ', postId);
                        console.log('update ID : ', update_id);

                        console.log('USER TYPE --', this.state.StudentData.user_type);
                        console.log('USER LEVEL --', this.state.StudentData.user_level);
                        console.log('USER ID --', this.state.StudentData.id);
                        console.log('Identity ID --', this.state.StudentData.id_proof);

                        //console.log('fetched data :', this.state.StudentData);
                        const { StudentData } = this.state;
                        const joiningDate = new Date(StudentData.join_date);
                        const resignDate = StudentData.resign_date ? new Date(StudentData.resign_date) : null;

                        //const method = "insert"

                        this.setState({ joiningDate, resignDate }, () => {
                            this.calculateDuration(this.state.joiningDate, this.state.resignDate);
                        });

                        //this.handleImageUpdate();
                        /* if (this.state.StudentData.image) {
                             this.setBase64AsFile(this.state.StudentData.image);
                           }*/

                        /*  StudentData.resign_date === "0000-00-00" && this.setState(prevState => ({
                           StudentData: { ...prevState.StudentData, resign_date: null }
                       }));*/

                    });


                } else {
                    console.log('No data found for id:', postId); // Log the user ID
                }
            } else {
                localStorage.removeItem('postId');
                this.setState({ method: "insert" });
                console.log('No id provided', this.state.StudentData);
                //const user_type = "Student";
                const { userCon } = this.props; 
                console.log('userCon :', userCon);

                this.setState(prevState => ({
                    StudentData: { ...prevState.StudentData, method: 'insert', user_type : userCon, }
                }));


                const joiningDate = new Date();
                const resignDate = new Date();
                this.setState({ joiningDate, resignDate }, () => {
                    this.calculateDuration(this.state.joiningDate, this.state.resignDate);
                }, () => {

                    console.log('join date', this.state.join_date);

                }
                );


            }
        } catch (error) {
            console.error('Error fetching user data s:', error);
        } finally {
            this.setState({ isLoading: false });
        }



    }

    componentDidMount() {
        this.fetchDatafromDB();
    }


    handleDateChange = (event) => {
        this.setState({ joiningDate: event.target.value });

    };

    handleInputChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleInput = (e) => {
        const { name, value } = e.target;
        let sanitizedValue = value === null ? '' : value;

        if (name === 'mobile' && !/^\d*$/.test(sanitizedValue)) {
            console.error('Mobile number must contain only digits');
            return; // Prevent further processing if the value is not numeric
        }

        if (name === 'mobile') {
            this.checkMobileExists(sanitizedValue, this.state.StudentData.mobile_ISD);
        }
        if (name === 'mobile_ISD') {
            this.checkMobileExists(this.state.StudentData.mobile, sanitizedValue);
        }
        if (name === 'email_address') {
            this.checkEmailExists(sanitizedValue);
        }

        if (name === 'email_address' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(sanitizedValue)) {
            console.error('Invalid email address');
            return; // Prevent further processing if the email is not valid
        }

        this.setState(prevState => ({
            StudentData: {
                ...prevState.StudentData,
                [name]: sanitizedValue
            }

        }), () => {

            console.log('Date', this.state.joiningDate);

        });

    };

    checkMobileExists = (mobile, isd) => {
        console.log("mobile isd : ", isd, mobile);
        this.setState({ mobileLoading: true, mobileExists: null, mobileExistsMessage: null });

        if (!/^\d*$/.test(mobile)) {
            this.setState({ mobileExists: false, saveDisabled: false, mobileLoading: false })

        }
        else {

            axios.get(`https://yesedacademy.com/database/check_mobile.php?isd=${isd}&mobile=${mobile}`)
                .then(response => {
                    if (response.data.exists) {
                        mobile !== this.state.DatabaseImg.mobile ? this.setState({ mobileExists: true, mobileExistsMessage: true, saveDisabled: true, mobileLoading: false }) : this.setState({ mobileExists: false, mobileExistsMessage: false, saveDisabled: false, mobileLoading: false });
                    } else {
                        this.setState({ mobileExists: false, mobileExistsMessage: false, saveDisabled: false, mobileLoading: false });
                    }
                })

                .catch(error => {
                    console.error('There was an error checking the mobile number!', error);
                    this.setState({ mobileLoading: false });
                });
        }

    };

    checkEmailExists = (email_address) => {
        this.setState({ emailLoading: true, emailExists: null, emailExistsMessage: null, emailNotValid: null });

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email_address)) {
            this.setState({ emailNotValid: true, saveDisabled: true, emailLoading: false, emailExists: true });
            this.setState(prevState => ({
                StudentData: { ...prevState.StudentData, email_address: null }
            }));

        }
        else if (email_address === null) {
            this.setState({ emailNotValid: true, saveDisabled: true, emailLoading: false, emailExists: true });
        }
        else {
            this.setState({ emailLoading: true, emailExists: null, emailExistsMessage: null });

            axios.get(`https://yesedacademy.com/database/check_email.php?email=${email_address}`)
                .then(response => {
                    if (response.data.exists) {
                        email_address !== this.state.DatabaseImg.email_address ? this.setState({ emailExists: true, emailExistsMessage: true, saveDisabled: true, emailLoading: false }) : this.setState({ emailExists: false, emailExistsMessage: false, saveDisabled: false, emailLoading: false });
                    } else {
                        this.setState({ emailExists: false, emailExistsMessage: false, saveDisabled: false, emailLoading: false });
                    }
                })
                .catch(error => {
                    console.error('There was an error checking the mobile number!', error);
                    this.setState({ emailLoading: false });
                });
        }
    };

    handleImageChange = (e) => {
        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
        const file = e.target.files[0];
        const reader = new FileReader();

        reader.onload = () => {
            const image = reader.result;
            //console.log('newww image : ', image);
            this.setState(prevState => ({
                StudentData: {
                    ...prevState.StudentData,
                    //image: reader.result || prevState.StudentData.image
                    original_image: image
                }
            }), () => {
                //console.log('image changed : ',image)
                // Call updatePreview after setting the image with a slight delay
                setTimeout(() => {
                    this.updatePreview();
                }, 100);

            });
        };

        if (file && allowedTypes.includes(file.type)) {
            reader.readAsDataURL(file);
        } else {
            // Notify the user that only JPG, JPEG, and PNG files are allowed
            alert('Please select a valid image file (JPG, JPEG, or PNG).');
            // Reset the file input value to prevent selecting an invalid file
            e.target.value = null;
            // Reset the avatar image to the database image if available, otherwise set it to null


            const updated_image = this.state.DatabaseImg.images;
            const databaseImage = updated_image ? updated_image : null;
            //console.log('new image e: ', updated_image);
            this.setState(prevState => ({
                StudentData: {
                    ...prevState.StudentData,
                    image: databaseImage
                }

            }), () => {
                //console.log('Image updatedddd:', this.state.StudentData.image);
                // Call updatePreview to reflect the change
                this.updatePreview();
            });
        }


    };

    handleImageUpdate = (e) => {
        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
        const file = this.StudentData.image;
        const reader = new FileReader();

        reader.onload = () => {
            const image = reader.result;
            this.setState(prevState => ({
                StudentData: {
                    ...prevState.StudentData,
                    image: image
                }
            }), () => {
                setTimeout(() => {
                    this.updatePreview();
                }, 100);

            });
        };

        if (file && allowedTypes.includes(file.type)) {
            reader.readAsDataURL(file);
        } else {
            alert('Please select a valid image file (JPG, JPEG, or PNG).');
            e.target.value = null;

            const updated_image = this.state.DatabaseImg.images;
            const databaseImage = updated_image ? updated_image : null;
            this.setState(prevState => ({
                StudentData: {
                    ...prevState.StudentData,
                    image: databaseImage
                }

            }), () => {
                this.updatePreview();
            });
        }


    };

    handleFileChange = (e) => {
        const reader = new FileReader();
        const file = e.target.files[0];
        reader.onload = () => {
            const file_pdf = reader.result;
            this.setState(prevState => ({
                StudentData: {
                    ...prevState.StudentData,
                    id_proof_1: file_pdf
                }
            }), () => {
                //console.log('dataaa changed : ', this.state.StudentData)

            });
        };

        if (file && file.type === 'application/pdf' && file.size <= 1500000) {
            reader.readAsDataURL(file);
        } else {

            alert('Please select a PDF file with a size below 1.5MB.');

            e.target.value = null;
            //const reader = new FileReader();

            const updated_Pdf = this.state.DatabaseImg.id_proof_1;
            const databasePdf = updated_Pdf ? updated_Pdf : null;

            this.setState(prevState => ({
                StudentData: {
                    ...prevState.StudentData,
                    id_proof_1: databasePdf
                }

            }), () => {

                //console.log('dataaa revert : ', this.state.StudentData)
            });

        }
    };

    /* previewPDF = (file) => {
         const reader = new FileReader();
         reader.onload = () => {
             const pdfFile = reader.result;
             this.setState(prevState => ({
                 StudentData: {
                     ...prevState.StudentData,
                     id_proof_1: pdfFile
                 }
             }));
         };
         //console.log("ddd : ", this.state.StudentData)
         //console.log("eee : ", this.state.DatabaseImg)
         reader.readAsDataURL(file);
     };*/

    handleFileChange2 = (e) => {
        const reader = new FileReader();
        const file = e.target.files[0];
        reader.onload = () => {
            const file_pdf = reader.result;
            this.setState(prevState => ({
                StudentData: {
                    ...prevState.StudentData,
                    id_proof_2: file_pdf
                }
            }), () => {
                //console.log('dataaa changed : ', this.state.StudentData)

            });
        };

        if (file && file.type === 'application/pdf' && file.size <= 1500000) {
            reader.readAsDataURL(file);
        } else {

            alert('Please select a PDF file with a size below 1.5MB.');

            e.target.value = null;

            const updated_Pdf = this.state.DatabaseImg.id_proof_2;
            const databasePdf = updated_Pdf ? updated_Pdf : null;
            this.setState(prevState => ({
                StudentData: {
                    ...prevState.StudentData,
                    id_proof_2: databasePdf
                }

            }), () => {
                //console.log('dataaa revert : ', this.state.StudentData)
            });
        }
    };

    openPDFTab2 = (pdfUrl) => {
        console.log('Opening PDF:', pdfUrl);
        window.open(pdfUrl, '_blank');

    }

    handleFileInputChange = (event) => {
        const selectedFile = event.target.files[0];

        const pdfUrl = URL.createObjectURL(selectedFile);

        const pdfData = new FormData();
        pdfData.append('id_proof_2', selectedFile);

        this.setState(prevState => ({
            StudentData: {
                ...prevState.StudentData,
                id_proof_2: pdfUrl,
                id_proof_file_2: pdfData
            }
        }), () => {

            this.openPDFTab2(pdfUrl);
        })


    };




    openPDF = (e) => {
        const file = e.target.files[0];
        this.setState(prevState => ({
            StudentData: {
                ...prevState.StudentData,
                id_proof_2: file
            }
        }), () => {

        })
    };


    PDFinNewTab = (data) => {
        if (this.isBase64(data)) {
            this.openPDFInNewTab(data);
        } else {
            this.openPDFTab(data);
        }
    }



    openPDFInNewTab = (pdfUrl) => {
        const newWindow = window.open('', '_blank');
        newWindow.document.title = 'PDF Viewer';
        newWindow.document.write(`<embed width="100%" height="100%" src="${pdfUrl}">`);
        //console.log('Opened PDF in new tab:', pdfUrl);
    };

    openPDFInNewTab2 = (pdfUrl) => {
        const newWindow = window.open('', '_blank');
        newWindow.document.title = 'PDF Viewer';
        newWindow.document.write(`<embed width="100%" height="100%" src="${pdfUrl}">`);
        //console.log('Opened PDF in new tab:', pdfUrl);
    };

    openPDFTab = (pdfUrl) => {
        console.log('Opening PDF:', pdfUrl);

        const url = `https://yesedacademy.com/database/${pdfUrl}`;
        window.open(url, '_blank');
    }



    handleZoomIn = () => {
        this.setState((prevState) => ({
            StudentData: {
                ...prevState.StudentData,
                scale: Math.min(prevState.StudentData.scale + 0.1, 8)
            }
        }), () => {
            this.updatePreview(); // Call updatePreview after zoom in
        });
    };


    handleZoomOut = () => {
        this.setState((prevState) => ({
            StudentData: {
                ...prevState.StudentData,
                scale: Math.max(prevState.StudentData.scale - 0.1, 1)
            }
        }), () => {
            this.updatePreview(); // Call updatePreview after zoom in
        });
    };

    handleXPosition = (e) => {
        const x = parseFloat(e.target.value);
        this.setState((prevState) => ({
            StudentData: {
                ...prevState.StudentData,
                position: {
                    ...prevState.StudentData.position,
                    x
                }
            }
        }), () => {
            this.updatePreview(); // Call updatePreview after changing X position
        });
    };

    handleYPosition = (e) => {
        const y = parseFloat(e.target.value);
        this.setState((prevState) => ({
            StudentData: {
                ...prevState.StudentData,
                position: {
                    ...prevState.StudentData.position,
                    y
                }
            }
        }), () => {
            this.updatePreview(); // Call updatePreview after changing Y position
        });
    };

    setEditorRef = editor => {
        if (editor) {
            this.editor = editor;
            this.updatePreview();
        }
    }

    handlePositionChange = (position) => {
        this.setState((prevState) => ({
            StudentData: {
                ...prevState.StudentData,
                position,
                
            }
        }));
    }

    rotateLeft = (e) => {
        e.preventDefault();
        this.setState((prevState) => ({
            StudentData: {
                ...prevState.StudentData,
                rotate: prevState.StudentData.rotate - 90
            }
        }), () => {
            this.updatePreview(); // Call updatePreview after rotating left
        });
    }

    rotateRight = (e) => {
        e.preventDefault();
        this.setState((prevState) => ({
            StudentData: {
                ...prevState.StudentData,
                rotate: prevState.StudentData.rotate + 90
            }
        }), () => {
            this.updatePreview(); // Call updatePreview after rotating right
        });
    }

    handleScale = (e) => {
        const scale = parseFloat(e.target.value);
        this.setState((prevState) => ({
            StudentData: {
                ...prevState.StudentData,
                scale
            }
        }), () => {
            this.updatePreview(); // Call updatePreview after changing scale
        });
    }

    handleScaleInputChange = (e) => {
        let newScale = parseFloat(e.target.value);
        // Ensure the new scale value is within the allowed range
        if (newScale < (this.state.allowZoomOut ? 0.1 : 1)) newScale = this.state.allowZoomOut ? 0.1 : 1;
        if (newScale > 8) newScale = 8;
        this.setState((prevState) => ({
            StudentData: {
                ...prevState.StudentData,
                scale: newScale
            }
        }), () => {
            this.handleScale({ target: { value: newScale } });
        });
    }

    handleRotateChange = (e) => {
        const rotate = parseFloat(e.target.value);
        this.setState((prevState) => ({
            StudentData: {
                ...prevState.StudentData,
                rotate
            }
        }), () => {
            this.updatePreview(); // Call updatePreview after changing rotation
        });
    }

    handleRotateNumberChange = (e) => {
        let newRotate = parseInt(e.target.value, 10);
        if (newRotate < -180) newRotate = -180;
        if (newRotate > 180) newRotate = 180;
        this.setState((prevState) => ({
            StudentData: {
                ...prevState.StudentData,
                rotate: newRotate
            }
        }));
    }


    updatePreview = () => {

        const img = new Image();
        img.src = this.editor.getImageScaledToCanvas().toDataURL();

        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');

            ctx.drawImage(img, 0, 0);

            const jpgImage = canvas.toDataURL('image/jpeg', 0.8);
            //console.log("image :" ,  );

            this.setState((prevState) => ({
                StudentData: {
                    ...prevState.StudentData,
                    preview: {
                        img: jpgImage,
                        scale: prevState.StudentData.scale,
                        width: 250,
                        height: 250,
                    },
                }
            }), () => {
                /* const { x, y } = this.state.position;
                 this.setState({ x, y });*/
                //this.convertBase64ToBlob();
                //console.log('Image pre : ', this.state.StudentData.preview.img);
                //this.handleImageConvert();
            });
        };
    };
    handleImageConvert = async (event) => {
        //event.preventDefault();
        const { image } = this.state.StudentData.image;

        // Decode the base64 image
        const byteString = atob(image.split(',')[1]);
        const arrayBuffer = new ArrayBuffer(byteString.length);
        const uint8Array = new Uint8Array(arrayBuffer);

        for (let i = 0; i < byteString.length; i++) {
            uint8Array[i] = byteString.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: 'image/png' });
        const formData = new FormData();
        formData.append('file', blob, 'image.png');
        console.log('Image Converted : ', formData);
    }

    handleSubmit = async (event) => {
        event.preventDefault();
        console.log('handle submit called');

        const formData = new FormData();
        formData.append('StudentData', JSON.stringify(this.state.StudentData));

        try {
            console.log('Student data trying to insert');
            console.log('handle submit data : ', formData);
            const response = await UserRegistration(this.state.StudentData);

            if (response.ok) {
                // Handle successful insertion
                console.log('handle submit data : ', formData);
                console.log('Student data inserted successfully!');
            } else {
                // Handle insertion failure
                console.error('Failed to insert student data.');
            }
        } catch (error) {
            console.error('Error inserting student data:', error);
        }
    };

    /* base64ToBlob = (base64, contentType = '', sliceSize = 512) => {
         const byteCharacters = atob(base64);
         const byteArrays = [];
     
         for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
           const slice = byteCharacters.slice(offset, offset + sliceSize);
           const byteNumbers = new Array(slice.length);
           for (let i = 0; i < slice.length; i++) {
             byteNumbers[i] = slice.charCodeAt(i);
           }
           const byteArray = new Uint8Array(byteNumbers);
           byteArrays.push(byteArray);
         }
     
         return new Blob(byteArrays, { type: contentType });
       };
     
       setBase64AsFile = (base64Image) => {
         const contentType = 'image/jpeg';
         const base64 = base64Image.split(',')[1]; // Remove the data URL part if it's included
         const blob = this.base64ToBlob(base64, contentType);
         const file = new File([blob], "uploaded_image.jpg", { type: contentType });
     
         // Create a DataTransfer to simulate file input
         const dataTransfer = new DataTransfer();
         dataTransfer.items.add(file);
         this.fileInputRef.current.files = dataTransfer.files;
     
         // Verify that the input file is set
         console.log("ref : ",this.fileInputRef.current.files);
       };
 
 */


    convertBase64ToBlob() {
        const img = new Image();
        img.src = this.state.StudentData.image;
        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);

            canvas.toBlob((blob) => {
                const url = URL.createObjectURL(blob);
                this.setState({ blobUrl: url });
            }, 'image/png');
        };
    }

    isBase64(str) {
        if (!str) return false;
        const base64Regex = /^(data:\w+\/[a-zA-Z+\-.]+;base64,)?([A-Za-z0-9+/]+[=]{0,2})+$/;
        return base64Regex.test(str);
    }

   

    handleSave = async (event) => {
        if (this.state.submitLoading) {
          return;
        }

    
        event.preventDefault();
        const userConfirmed = window.confirm(`Are you sure you want to ${this.state.StudentData.method} this review?`);
    
        if (userConfirmed) {
          const requiredInputs = document.querySelectorAll('#name, #last_name, #mobile, #role, #email_address, #join_date');
          let allInputsValid = true;
    
          for (let i = 0; i < requiredInputs.length; i++) {
            if (requiredInputs[i].value.trim() === '') {
              allInputsValid = false;
              //this.setState({ saveDisabled: true });
              alert('Please fill out all required fields.');
              break; // Exit the loop on finding an empty input
            }
          }
    
          if (allInputsValid) {
            this.setState({ submitLoading: true });
    
            try {
              const response = await fetch('https://yesedacademy.com/database/userRegistration.php', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(this.state.StudentData)
              });
    
              const result = await response.json();
              console.log("Response : ", result);
    
              if (result.status === 'success') {
                this.setState({ submitLoading: false });
                alert(result.message);
                this.state.StudentData.user_type == "Student" ? this.props.navigate('/students/list') : this.props.navigate('/employee/list');
                //window.location.href = '/view-reviews';
                // handle success (e.g., redirect or update UI)
    
    
              } else {
                this.setState({ submitLoading: false });
                alert(result.message);
                // handle error (e.g., display error message)
              }
            } catch (error) {
              console.error('Failed to fetch:', error);
              this.setState({ submitLoading: false });
              alert('Failed to save the review. Please try again later.');
            }
          }
        }
      }





    render() {


        const { StudentData, isLoading, submitLoading, mobileLoading, emailLoading } = this.state;
        const { mobileExists, emailExists, mobileExistsMessage, emailExistsMessage, emailNotValid, saveDisabled } = this.state;
        const { joiningDate, resignDate, years, months, days } = this.state;
        let duration;



        if (years > 0) {
            duration = `${years} year${years > 1 ? 's' : ''}, ${months} month${months > 1 ? 's' : ''}, ${days} day${days > 1 ? 's' : ''}`;
        } else if (years === 0 && months > 0) {
            duration = `${months} month${months > 1 ? 's' : ''}, ${days} day${days > 1 ? 's' : ''}`;
        } else {
            duration = `${days} day${days > 1 ? 's' : ''}`;
        }



        

       // console.log('userCon : ', userCon);






       /* console.log("Save Method : ", this.state.StudentData.method);
        console.log('JDate : ', this.state.StudentData.join_date);
        console.log('RDate : ', this.state.StudentData.resign_date);
        console.log('RDate2 : ', this.state.resignDate);
        console.log('Image : ', this.state.StudentData.image);
        console.log('Image_loc : ', this.state.StudentData.image_loc);
        //console.log('Image pre : ', this.state.preview.img);
        console.log('Post IDDD : ', this.state.StudentData.id);
        console.log('Scale : ', this.state.scale);
        console.log('Position : ', this.state.position);
        console.log('x : ', this.state.x);
        console.log('y : ', this.state.y);
        console.log('Rotate : ', this.state.rotate);
        console.log('Decoded image : ', this.state.blobUrl);
        console.log('ID Proof 2 : ', this.state.StudentData.id_proof_file_2);
        console.log('ISD : ', this.state.StudentData.mobile_ISD);*/

        console.log('Data : ', this.state.StudentData);




        return (


            <div>
                {isLoading ? (
                    <Loading size={100} />
                ) : StudentData ? (
                    <div>
                        

                            <div className="container" >
                                <div className="row mt-2" >

                                    <div className="col-md-11"></div>
                                    <div className="col-md-1 align-items-right">
                                        <div className="d-flex justify-content-start align-items-center ">
                                            <div>
                                                {submitLoading ? <span><Loading size={20} /></span> :
                                                    <button className='no-hover' onClick={this.handleSave} id="user_registration" name="user_registration" type='submit' disabled={saveDisabled}>
                                                        <span><Save className='ico-button' aria-label="Edit" /> Save</span></button>
                                                }
                                            </div>
                                            <span className='p-3'>  </span>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="container rounded bg-white mt-5 mb-5">

                                <div className="row">
                                    <div className="col-md-15 border-right">
                                        <div className="d-flex flex-column align-items-center text-center p-3 py-5">
                                            <h4 className="text-right">Profile Picture</h4>



                                            {this.state.StudentData.original_image && (
                                                <div>

                                                    <AvatarEditor
                                                        ref={this.setEditorRef}
                                                        scale={parseFloat(this.state.StudentData.scale)}
                                                        onScaleChange={(scale) => {
                                                            this.setState((prevState) => ({
                                                                StudentData: {
                                                                    ...prevState.StudentData,
                                                                    scale
                                                                }
                                                            }));
                                                            this.updatePreview(); // Update preview when scale changes
                                                        }}
                                                        position={this.state.StudentData.position}
                                                        onPositionChange={(position) => {
                                                            this.setState((prevState) => ({
                                                                StudentData: {
                                                                    ...prevState.StudentData,
                                                                    position
                                                                }
                                                            }));
                                                            this.updatePreview(); // Update preview when position changes
                                                        }}
                                                        rotate={parseFloat(this.state.StudentData.rotate)}
                                                        onRotateChange={(rotate) => {
                                                            this.setState((prevState) => ({
                                                                StudentData: {
                                                                    ...prevState.StudentData,
                                                                    rotate
                                                                }
                                                            }));
                                                            this.updatePreview(); // Update preview when rotate changes
                                                        }}
                                                        image={this.state.StudentData.original_image}
                                                        width={250}
                                                        height={250}
                                                        border={0}
                                                        color={[255, 255, 255, 0.6]}
                                                        className="avatar-editor"
                                                        crossOrigin="anonymous"
                                                        borderRadius={250 / 2}
                                                        onImageChange={this.state.updatePreview}
                                                    />

                                                    <div className="zoom-controls ">
                                                        Zoom
                                                        <br></br>
                                                        <input className='range-input'
                                                            name="scale" type="range" onChange={this.handleScale}
                                                            min={this.state.StudentData.allowZoomOut ? "0.1" : "1"}
                                                            max="8"
                                                            step="0.01"
                                                            //defaultValue={this.state.StudentData.scale !== null ? this.state.StudentData.scale : "1"}
                                                            value={this.state.StudentData.scale}
                                                            ref={this.scaleInputRef}

                                                        />
                                                        <input
                                                            className="number-input"
                                                            type="number"
                                                            value={this.state.StudentData.scale}
                                                            style={{ width: '70px' }}
                                                            onChange={this.handleScaleInputChange}
                                                            step="0.01"
                                                            min={this.state.StudentData.allowZoomOut ? "0.1" : "1"}
                                                            max="8"
                                                        />
                                                    </div>
                                                    <div className="zoom-controls ">

                                                        Rotate
                                                        <br></br>
                                                        <input
                                                            className='range-input'
                                                            type="range"
                                                            id="rotate"
                                                            name="rotate"
                                                            min="-180"
                                                            max="180"
                                                            step="1"
                                                            value={this.state.StudentData.rotate}
                                                            //defaultValue={this.state.StudentData.rotate !== null ? this.state.StudentData.rotate : "0"}
                                                            // defaultValue="0"
                                                            onChange={this.handleRotateChange}
                                                            ref={this.rotateInputRef}
                                                        />
                                                        <input
                                                            className="number-input"
                                                            type="number"
                                                            value={this.state.StudentData.rotate}
                                                            style={{ width: '70px' }}
                                                            onChange={this.handleRotateNumberChange}
                                                            step="1"
                                                            min="-180"
                                                            max="180"

                                                        />

                                                    </div>
                                                    {this.state.preview && (

                                                        <input type="text" name="photo" id="photo" hidden value={this.state.preview.img} />


                                                    )}
                                                </div>
                                            )}
                                            <div className="col-md-14"><input type="file" name='image' id='image' className="form-control" onChange={this.handleImageChange}
                                                required={this.state.StudentData.image === null} /></div>



                                        </div>
                                    </div>
                                    <div className="col-md-16 border-right">
                                        <div className="p-3 py-5">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <h4 className="text-right">Personal Information </h4>
                                            </div>
                                            <div className="row mt-2">
                                                <div className="col-md-12"><label className="labels">Name *</label></div>
                                                <div className="col-md-18 mt-1">
                                                    <input type="text" className="form-control" id='name' name='name' value={StudentData.name} placeholder='First Name *' required onChange={this.handleInput} />
                                                </div>

                                                <div className="col-md-19 mt-1">
                                                    <input type="text" className="form-control" id='middle_name' name='middle_name' value={StudentData.middle_name} placeholder='Middle Name' onChange={this.handleInput} />
                                                </div>

                                                <div className="col-md-20 mt-1">
                                                    <input type="text" className="form-control" id='last_name' name='last_name' value={StudentData.last_name} placeholder='Last Name *' required onChange={this.handleInput} />
                                                </div>
                                            </div>

                                            <EditUserInfoRow type="text" label="Email" id="personal_email" value={StudentData.personal_email} onChange={this.handleInput} />
                                            <PhoneNumberInput type="number" label="Mobile *" id="mobile" value={StudentData.mobile} value_ISD={StudentData.mobile_ISD} required="required" onChange={this.handleInput} status={<SuccessIcon loading={mobileLoading} exists={mobileExists} />} />


                                            {mobileExistsMessage === true && (
                                                <div className="text-danger mt-2">Mobile number already exists.</div>
                                            )}

                                            <EditUserInfoRow type="text" label="Address" id="address_1" value={StudentData.address_1} onChange={this.handleInput} />
                                            <EditUserInfoRow type="text" id="address_2" value={StudentData.address_2} onChange={this.handleInput} />
                                            <EditUserInfoRow type="text" id="address_3" value={StudentData.address_3} onChange={this.handleInput} />
                                            <EditUserInfoRow type="text" id="city" label="City" value={StudentData.city} onChange={this.handleInput} />
                                            <EditUserInfoRow type="text" id="state" label="State" value={StudentData.state} onChange={this.handleInput} />
                                            <EditUserInfoRow type="number" id="pincode" label="Pincode" value={StudentData.pincode} onChange={this.handleInput} />

                                        </div>
                                    </div>
                                    <div className="col-md-17">


                                        <div className="p-3 py-5">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <h4 className="text-right">Job Information</h4>
                                            </div>
                                           
                                            <EditUserInfoRow type="text" id="role" label="User Type *" required="required" value={StudentData.user_type} readOnly='readOnly'/>
                                            <EditUserInfoRow type="text" id="role" label="Role *" required="required" value={StudentData.role} onChange={this.handleInput} />
                                            <EditUserInfoRow type="text" id="email_address" label="Email *" required="required" value={StudentData.email_address} onChange={this.handleInput} status={<SuccessIcon loading={emailLoading} exists={emailExists} valid={emailNotValid} />} />

                                            {emailExistsMessage && (
                                                <div className="text-danger mt-2">Email address already exists.</div>
                                            )}
                                            {emailNotValid === true && (
                                                <div className="text-danger mt-2">Not a valid email address</div>
                                            )}
                                            <EditUserInfoRow type="date" id="join_date" label="Date of Joining *" value={StudentData.join_date} required="required" onChange={this.handleInput} />
                                            {this.state.StudentData.method == 'update' && <EditUserInfoRow type="date" id="resign_date" label="Resigned Date" value={StudentData.resign_date != null && StudentData.resign_date} onChange={this.handleInput} />}
                                            <UserInfoRow label="Duration" value={duration} />


                                            {resignDate !== "" ? <div> <UserInfoRow label="Status" value="Resigned" /></div> : <UserInfoRow label="Status" value="Currently Employed" />}
                                        </div>
                                        <div className="p-3 py-5">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <h4 className="">Identity Proof Details</h4>
                                            </div>
                                            <UserInfoRow label="Identity Proof 1" style={{ fontWeight: 'bold' }} />
                                            <EditUserSelect id="id_type_1" label="ID Proof Type" idType_1="Aadhaar" idType_2="Passport" idType_3="Electoral Voter" value={StudentData.id_type_1} onChange={this.handleInput} />
                                            <EditUserInfoRow type="text" id="id_no_1" label="ID Proof Number" value={StudentData.id_no_1} onChange={this.handleInput} />
                                            <EditUserProofRow type="file" id="id_proof_11" onChange={this.handleFileChange}
                                                value={StudentData.id_proof_1}
                                                onClick={() => this.PDFinNewTab(StudentData.id_proof_1)} />

                                            <UserInfoRow label="Identity Proof 2" style={{ fontWeight: 'bold' }} />
                                            <EditUserSelect id="id_type_2" label="ID Proof Type" idType_1="Aadhaar" idType_2="Passport" idType_3="Electoral Voter" value={StudentData.id_type_2} onChange={this.handleInput} />
                                            <EditUserInfoRow type="text" id="id_no_2" label="ID Proof Number" value={StudentData.id_no_2} onChange={this.handleInput} />
                                            <EditUserProofRow type="file" id="id_proof_22" label="Identity Proof 2" onChange={this.handleFileChange2}
                                                value={StudentData.id_proof_2}
                                                onClick={() => this.PDFinNewTab(StudentData.id_proof_2)} />




                                        </div>
                                    </div>
                                </div>
                                <input type="text" name="actionToPerform" id="actionToPerform" hidden value={this.state.StudentData.method} />
                                <input type="text" name="user_type" id="user_type" hidden value={this.state.StudentData.user_type} />
                                <input type="text" name="user_level" id="user_level" hidden value={this.state.StudentData.user_level} />
                                <input type="text" name="id_proof_1" id="id_proof_1" hidden value={this.state.StudentData.id_proof_1} />
                                <input type="text" name="id_proof_2" id="id_proof_2" hidden value={this.state.StudentData.id_proof_2} />
                                <input type="text" name="id" id="id" hidden value={this.state.StudentData.id} />
                                <input type="text" name="identity_id" id="identity_id" hidden value={this.state.StudentData.id_proof} />
                                <input type="text" name="image" id="image" hidden value={this.state.StudentData.image} />
                                <input type="text" name="scale" id="scale" hidden value={this.state.scale} />
                                <input type="text" name="position_x" id="position_x" hidden value={this.state.x} />
                                <input type="text" name="position_y" id="position_y" hidden value={this.state.y} />
                                <input type="text" name="rotate" id="rotate" hidden value={this.state.rotate} />
                                <input type="text" name="id_proof_file2" id="id_proof_file2" hidden value={this.state.StudentData.id_proof_file_2} />
                                <input type="text" name="insert" id="insert" hidden value={this.state.StudentData.name} />

                            </div>
                       
                    </div>

                ) : (
                    <p>No data available</p>
                )}

            </div>


        );
    }
}

export default withNavigation(UserNewEntry);
